import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariableGroup } from '../../Models/globalVariableGroup';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariableService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAllGlobalVariables() {
    return this.http.get<any[]>('/api/globalVariable/getAllGlobalVariables');
  }

  removeGlobalVariable(globalVariableName: string) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: { globalVariableName: globalVariableName },
    };
    return this.http.delete('api/globalVariable/removeGlobalVariable', options);
  }

  saveGlobalVariable(globalVariable: any) {
    return this.http.post<void>('api/globalVariable/saveGlobalVariable', globalVariable);
  }

  updateGlobalVariable(globalVariable: any) {
    return this.http.put('api/globalVariable/updateGlobalVariable', globalVariable);
  }

  getAllGlobalVariableGroups() {
    return this.http.get<GlobalVariableGroup[]>('/api/globalVariable/getAllGlobalVariablesGroups');
  }

  getGlobalVariableGroup(globalVariableGroupId: number) {
    return this.http.get<GlobalVariableGroup>(`/api/globalVariable/getGlobalVariableGroup/${globalVariableGroupId}`);
  }

  getAllOverriddenGlobalVariables() {
    return this.http.get<any[]>('/api/globalVariable/getAllOverriddenGlobalVariables');
  }

  updateGlobalVariableGroup(globalVariableGroup: GlobalVariableGroup) {
    return this.http.put('api/globalVariable/updateGlobalVariableGroup', globalVariableGroup);
  }

  createGlobalVariableGroup(globalVariableGroup: GlobalVariableGroup) {
    return this.http.post<number>('api/globalVariable/createGlobalVariableGroup', globalVariableGroup);
  }

  removeGlobalVariableGroup(globalVariableGroup: GlobalVariableGroup) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: globalVariableGroup,
    };
    return this.http.delete('api/globalVariable/removeGlobalVariableGroup', options);
  }

  getDefaultGlobalVariable(globalVariable: any) {
    return this.http.post<any>('api/globalVariable/getDefaultGlobalVariable', globalVariable);
  }
}
